const SignoffOverview = ({ data }) => {
  const {
    sign_off_client_name,
    sign_off_title,
    sign_off_date,
    sign_off_signature_type,
    sign_off_signature,
  } = data;
  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid gap-sm" className="">
        <div i2c-grid="6@md">
          <div i2c-grid="grid gap-sm" className="">
            <div i2c-grid="12@md">
              <div className="overview-help-text font-bold">Client Name</div>
              <div className="overview-val-text">
                {sign_off_client_name?.length
                  ? sign_off_client_name.toUpperCase()
                  : "-"}
              </div>
            </div>
            <div i2c-grid="12@md">
              <div className="overview-help-text font-bold">Client Title</div>
              <div className="overview-val-text">
                {sign_off_title?.length ? sign_off_title.toUpperCase() : "-"}
              </div>
            </div>
            <div i2c-grid="12@md">
              <div className="overview-help-text font-bold">Signature Date</div>
              <div className="overview-val-text">
                {sign_off_date?.length ? sign_off_date.toUpperCase() : "-"}
              </div>
            </div>
          </div>
        </div>
        <div i2c-grid="6@md">
          <img src={sign_off_signature?.length ? sign_off_signature : ""} />
        </div>
      </div>
    </div>
  );
};
export default SignoffOverview;
